import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-company-signature',
    templateUrl: './company-signature.component.html',
    styleUrls: ['./company-signature.component.scss'],
    standalone: false
})
export class CompanySignatureComponent {
  @Input() dark: boolean = false;
  public version: string = environment.version;
}
